import { rest, DefaultBodyType, PathParams } from 'msw';

import { fullMessageWithCTA, simpleMessageWithoutCTA } from '../../fixtures/iterable';
import { UserMessages } from '../../api';

const API_ROOT = `https://api.iterable.com/api`;

// Avoiding showing Iterable messages to test user by default so it doesn't pollute local envs
const ALLOWED_USER_IDS = ['22', '33'];

type EmptyResponse = UserMessages & PathParams;

const EMPTY_RESPONSE: EmptyResponse = { inAppMessages: [] };

export const iterableGetMessages = rest.get<DefaultBodyType, EmptyResponse>(
  `${API_ROOT}/inApp/getMessages`,
  (req, res, context) => {
    if (window.__TESTS__) {
      return undefined;
    }

    // Feel free to set FORCE_MOCK_ITERABLE_API to any truthy value in your local .env file
    // to force msw returning some Iterable messages in case you need it for your local app.
    if (process.env.FORCE_MOCK_ITERABLE_API) {
      return res(context.status(200), context.json(fullMessageWithCTA));
    }

    const userId = req.url.searchParams.get('userId');
    if (userId && ALLOWED_USER_IDS.includes(userId)) {
      return res(context.status(200), context.json(simpleMessageWithoutCTA));
    }

    return res(context.status(200), context.json(EMPTY_RESPONSE));
  },
);
